var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content animate-panel", attrs: { id: "page-notices" } },
    [
      _c("h2", { staticClass: "m-n" }, [_vm._v("お知らせ")]),
      _vm._v(" "),
      _vm.pageData.length > 0
        ? _c("div", { staticClass: "hpanel" }, [
            _c("div", { staticClass: "panel-body", attrs: { id: "notices" } }, [
              _c(
                "div",
                {
                  staticClass: "hpanel panel-group",
                  attrs: {
                    id: "accordion",
                    role: "tablist",
                    "aria-multiselectable": "true"
                  }
                },
                _vm._l(_vm.pageData, function(notice, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "panel-body",
                      attrs: { id: "panel-notice-" + notice.id }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "collapsed pointer-cursor accordion-title",
                          attrs: {
                            "data-toggle": "collapse",
                            "data-parent": "#accordion",
                            "data-target": "#collapse-notice-" + notice.id,
                            "aria-expanded": "false"
                          },
                          on: {
                            click: function($event) {
                              _vm.handleCollapseNotice(notice)
                            }
                          }
                        },
                        [
                          _c("div", [
                            _c("p", [
                              _vm._v(
                                "\n                " +
                                  _vm._s(notice.date) +
                                  "\n                "
                              ),
                              !notice.is_notice_read
                                ? _c(
                                    "span",
                                    { staticClass: "notice_read_flg" },
                                    [_vm._v("未読")]
                                  )
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.replaceHTMLSellerInfo(notice.title)
                                )
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c("i", {
                            staticClass:
                              "fa fa-chevron-down text-muted accordion-arrow"
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "panel-collapse collapse",
                          attrs: {
                            id: "collapse-notice-" + notice.id,
                            "aria-expanded": "false"
                          }
                        },
                        [
                          _c("hr"),
                          _vm._v(" "),
                          _c("p", {
                            staticClass: "m-l",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.replaceHTMLSellerInfo(notice.content)
                              )
                            }
                          })
                        ]
                      )
                    ]
                  )
                }),
                0
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("pagination", {
            attrs: { url: "Notice" },
            on: { onChangePage: _vm.onChangePage }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fde2c22c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fde2c22c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/Notices.vue
// module id = null
// module chunks = 